import { j as a } from "../../modules/index.es3.js";
import { Root as h, Trigger as N, Portal as y, Overlay as i, Close as j, Content as m, Title as d, Description as n } from "../../modules/index.es25.js";
import * as r from "react";
import { cn as o } from "../../utils/styling.es.js";
import { sheetVariants as g } from "./Sheet.styles.es.js";
import u from "../Button/Button.es.js";
import S from "../../modules/index.es26.js";
const B = h, E = N, R = y, c = r.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ a.jsx(
  i,
  {
    className: o(
      "fixed inset-0 z-50 bg-gray-700/40 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: s
  }
));
c.displayName = i.displayName;
const w = r.forwardRef(({ className: e, children: t, ...s }, l) => /* @__PURE__ */ a.jsx(j, { asChild: !0, children: /* @__PURE__ */ a.jsx(
  u,
  {
    ref: l,
    asChild: !0,
    "aria-label": "Close",
    icon: !0,
    variant: "ghost",
    appearance: "gray",
    size: "sm",
    className: o("absolute right-2 top-2", e),
    ...s,
    children: /* @__PURE__ */ a.jsx(S, { className: "h-5" })
  }
) })), C = r.forwardRef(
  ({
    side: e = "right",
    className: t,
    children: s,
    disableCloseButton: l = !1,
    disableOverlay: f = !1,
    ...p
  }, x) => /* @__PURE__ */ a.jsxs(R, { children: [
    !f && /* @__PURE__ */ a.jsx(c, {}),
    /* @__PURE__ */ a.jsxs(
      m,
      {
        ref: x,
        className: o(g({ side: e }), t),
        ...p,
        children: [
          s,
          !l && /* @__PURE__ */ a.jsx(w, {})
        ]
      }
    )
  ] })
);
C.displayName = m.displayName;
const b = ({
  className: e,
  ...t
}) => /* @__PURE__ */ a.jsx(
  "div",
  {
    className: o(
      "flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...t
  }
);
b.displayName = "SheetHeader";
const v = ({
  className: e,
  ...t
}) => /* @__PURE__ */ a.jsx(
  "div",
  {
    className: o(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
v.displayName = "SheetFooter";
const T = r.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ a.jsx(
  d,
  {
    ref: s,
    className: o("text-lg font-semibold text-foreground", e),
    ...t
  }
));
T.displayName = d.displayName;
const F = r.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ a.jsx(
  n,
  {
    ref: s,
    className: o("text-sm text-foreground", e),
    ...t
  }
));
F.displayName = n.displayName;
export {
  B as Sheet,
  w as SheetClose,
  C as SheetContent,
  F as SheetDescription,
  v as SheetFooter,
  b as SheetHeader,
  c as SheetOverlay,
  R as SheetPortal,
  T as SheetTitle,
  E as SheetTrigger
};
//# sourceMappingURL=Sheet.es.js.map
